export const couponCodesState = {
  data: {
    coupon: null,
    coupons: [],
    couponAction: null,
    couponsCount: 0,
    formAction: '',
  },
  error: null,
  filters: {
    state: 'all',
    pagesCount: 0,
    totalCount: 0,
    currentPage: 1,
    perPage: 25,
  },
  loading: true,
  modalAction: null,
}
